import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "userListingPage" }
const _hoisted_2 = { class: "head" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("Manage your "),
  /*#__PURE__*/_createElementVNode("span", null, "Prices")
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Create Price ")
const _hoisted_5 = { class: "tableSec" }
const _hoisted_6 = { class: "actionblock" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "spinners"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_addNewPriceModal = _resolveComponent("addNewPriceModal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_a_button, {
        type: "primary",
        size: "large",
        block: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addNewPrice()))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_a_table, {
        columns: _ctx.priceColumns,
        "data-source": _ctx.priceLists,
        class: "",
        rowKey: "id",
        pagination: false
      }, {
        action: _withCtx(({ record }) => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_EditOutlined, {
              onClick: ($event: any) => (_ctx.editPrice(record.id)),
              style: { fontSize: '20px' }
            }, null, 8, ["onClick"]),
            _createElementVNode("div", {
              class: "deleI",
              onClick: ($event: any) => (_ctx.showDeleteConfirm(record.id))
            }, [
              _createVNode(_component_DeleteOutlined)
            ], 8, _hoisted_7)
          ])
        ]),
        _: 1
      }, 8, ["columns", "data-source"])
    ]),
    (_ctx.pageLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_a_spin)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      title: _ctx.addEditPriceTitle,
      width: "600px",
      class: "candidate-dashboard-modal",
      visible: _ctx.creatPriceVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.creatPriceVisible) = $event)),
      "cancel-button-props": { style: 'display:none' },
      "ok-button-props": { style: 'display:none' },
      maskClosable: false,
      destroyOnClose: true,
      centered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_addNewPriceModal, {
          PriceID: _ctx.priceId,
          onClosePriceModal: _ctx.closePriceModal
        }, null, 8, ["PriceID", "onClosePriceModal"])
      ]),
      _: 1
    }, 8, ["title", "visible"])
  ]))
}